module.exports = __webpack_public_path__ + "img/arrow.0619f4de.svg";